/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoSlackIcon24Solid = forwardRef('LogoSlackIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M14 2a2 2 0 0 0-2 2v5a2 2 0 1 0 4 0V4a2 2 0 0 0-2-2Z" }),
        React.createElement("path", { d: "M19.25 6.5A2.25 2.25 0 0 0 17 8.75v1.607c0 .355.288.643.643.643h1.607a2.25 2.25 0 0 0 0-4.5Z" }),
        React.createElement("path", { d: "M20 12a2 2 0 1 1 0 4h-5a2 2 0 1 1 0-4h5Z" }),
        React.createElement("path", { d: "M17.5 19.25A2.25 2.25 0 0 0 15.25 17h-1.607a.643.643 0 0 0-.643.643v1.607a2.25 2.25 0 0 0 4.5 0Z" }),
        React.createElement("path", { d: "M12 20a2 2 0 1 1-4 0v-5a2 2 0 1 1 4 0v5Z" }),
        React.createElement("path", { d: "M4.75 17.5A2.25 2.25 0 0 0 7 15.25v-1.607A.643.643 0 0 0 6.357 13H4.75a2.25 2.25 0 0 0 0 4.5Z" }),
        React.createElement("path", { d: "M4 12a2 2 0 1 1 0-4h5a2 2 0 1 1 0 4H4Z" }),
        React.createElement("path", { d: "M6.5 4.75A2.25 2.25 0 0 0 8.75 7h1.607A.643.643 0 0 0 11 6.357V4.75a2.25 2.25 0 0 0-4.5 0Z" })));
});
